import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    NOTIFY_LICENSE_CU_USAGE,
    RESPOND_LICENSE_DETAIL,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/license/license";
import { ChronosLicense, LicenseCUUsageData } from "userful-chronos-app-common-js/dist/models/license/license";
import { licenseActions } from "../licenseSlice";
import licenseStore from "../licenseStore";

//
registerMsgHandler(RESPOND_LICENSE_DETAIL, (payload) => {
    console.debug("receive RESPOND_LICENSE_DETAIL");
    const data = JSON.parse(payload) as ChronosLicense;
    licenseStore.dispatch(licenseActions.setLicense(data));
});

registerMsgHandler(NOTIFY_LICENSE_CU_USAGE, (payload) => {
    console.debug("receive NOTIFY_LICENSE_CU_USAGE");
    const data = JSON.parse(payload) as LicenseCUUsageData;
    licenseStore.dispatch(licenseActions.setLicenseCUUsage(data));
});
